import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function InHomeNursing() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-922">
      <Navbar data-id="element-923" />
      <main className="flex-1" data-id="element-924">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-925">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-926">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-927">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-928" />
              Care Solutions
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-929">
              In-Home Nursing
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-930">
              Professional nursing care delivered in the comfort of your home.
              Wound care, medication management, post-surgical support, and
              chronic disease monitoring.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-931">
          <p data-id="element-932">
            Our In-Home Nursing services provide professional, compassionate
            care in the comfort of your own home. Our Registered Nurses (RNs)
            and Registered Practical Nurses (RPNs) are trained to deliver a wide
            range of clinical services, from wound care and IV therapy to
            medication administration and chronic disease management.
          </p>
          <p data-id="element-933">
            Whether you need post-surgical recovery care, ongoing support for a
            chronic condition, or specialized care for a loved one, our in-home
            nursing team is here to help. Every care plan is nurse-supervised,
            ensuring the highest standards of clinical quality and patient
            safety.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-934" />
    </div>;
}